import { render, staticRenderFns } from "./projectcategory.vue?vue&type=template&id=2b4a6974&"
import script from "./projectcategory.vue?vue&type=script&lang=js&"
export * from "./projectcategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports